import { apiSlice } from "../../api/ApiService";

const userDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserDetails: builder.query({
      query: ({
        accessToken,
        inputValue,
      }: {
        accessToken: string | null;
        inputValue: string;
        count: number;
      }) => ({
        url: `/api/v1/Administration/${inputValue}/search-user`,
        method: "GET",
        headers: accessToken && { Authorization: `Bearer ${accessToken}` },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetUserDetailsQuery } = userDetailsApi;
export default userDetailsApi;
